import { Component, HostListener } from '@angular/core';
import { ICellRendererParams } from '@ag-grid-community/core';

@Component({
    selector: 'filter-cell',
    template: `
        <div class="div-filter-cell">
            <p-icon name="bell" size="xs"></p-icon>
            <span class="text">{{ value | translate }}</span>
        </div>
    `,
    styleUrls: ['./full-width-cell-renderer.component.scss']
})
export class FullWidthCellRendererComponent {
    public value!: string;

    @HostListener('click', ['$event'])
    @HostListener('dblclick', ['$event'])
    handleClick(event: PointerEvent): void {
        event.stopPropagation();
        event.preventDefault();
    }

    agInit(params: ICellRendererParams): void {
        this.value = params?.value;
    }
}
